import { Injectable } from '@angular/core';
import { CryptService } from '../services/crypt.service';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {
  private storage: Storage;

  constructor(private crypt: CryptService) {
    this.storage = window.localStorage;
  }

  set(key: string, value: any): boolean {
    if (this.storage) {
      this.storage.setItem(key, JSON.stringify(value));
      return true;
    }
    return false;
  }

  get(key: string): any {
    if (this.storage) {
      return JSON.parse(<any>this.storage.getItem(key));
    }
  }

  remove(key: string): boolean {
    if (this.storage) {
      this.storage.removeItem(key);
      return true;
    }
    return false;
  }

  clear(): boolean {
    if (this.storage) {
      this.storage.clear();
      return true;
    }
    return false;
  }

  decryptAndGet(key: string) {
    const item = this.storage.getItem(key);

    if (item) {
      try {
        const itemParsed = JSON.parse(item);

        if (Array.isArray(itemParsed)) {
          return itemParsed.map((i: any) => this.crypt.decryptBy(i));
        } else {
          return this.crypt.decryptBy(itemParsed);
        }
      } catch (error) {
        return null;
      }
    }
    return null;
  }
}
